import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  // In demo mode, don't gate the UI — if the user hasn't authenticated yet,
  // show a friendly banner instead of redirecting.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0f1a] text-slate-400">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 rounded-full border-2 border-slate-700 border-t-blue-500 animate-spin" />
          <span className="text-xs uppercase tracking-[0.2em]">Loading…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
